module.exports = __webpack_public_path__ + "img/new-vroom.64309b8d.png";